"use strict";
/**
 *
 * TagsSettings
 *
*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const uuid_1 = require("uuid");
const luxon_1 = require("luxon");
const tags_1 = require("companion-app-components/flux/tags");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const QTag_1 = __importStar(require("components/QTag"));
const QButton_1 = __importDefault(require("components/QButton"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const tag_icon_inline_svg_1 = __importDefault(require("assets/nav-menu/tag-icon.inline.svg"));
const QDialogs_1 = __importDefault(require("components/QDialogs"));
const utils_1 = require("data/transactions/utils");
const core_1 = require("companion-app-components/utils/core");
const Dump_1 = __importDefault(require("components/Dump"));
const utils_2 = require("../../utils");
const styles = ({ palette, spacing, typography }) => ({
    sectionHeadline: {
        marginBottom: spacing(2),
    },
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.text.secondary,
    },
    iconSpacing: {
        marginRight: spacing(1),
    },
    tagsContainer: {
        border: `1px solid ${palette.divider}`,
        padding: spacing(2),
        borderRadius: 20,
        overflow: 'hidden',
        position: 'relative',
    },
    chip: {
        margin: spacing(1 / 2),
    },
    noData: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        padding: `${spacing(4)} 0`,
    },
});
const ID_NEW = '0';
const TAG_NEW = '';
const useStyles = (0, mui_1.makeStyles)()(styles);
const TagsSettings = (props) => {
    const { isLoading, data, getItems, createItem, updateItem, dialogAlert, txnsProps, deleteItem, tagsCharFilter, } = props;
    const { classes } = useStyles();
    (0, react_1.useEffect)(() => {
        getItems();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const [tagData, setTagData] = (0, react_1.useState)((0, utils_2.sortTagData)((0, utils_2.makeLocalTagData)(data)));
    const [editing, setEditing] = (0, react_1.useState)(null);
    const [editingTag, setEditingTag] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setTagData((0, utils_2.sortTagData)((0, utils_2.makeLocalTagData)(data)));
    }, [data]);
    const handleRequestCreate = () => {
        const newIndex = tagData.findIndex((x) => x.id === ID_NEW);
        if (newIndex < 0) {
            // createdAt time will be replaced with 'real' time upon refresh, it is set here so the sort order is not broken
            const newItem = tags_1.tagsTypes.mkTag({ id: ID_NEW, name: TAG_NEW, createdAt: luxon_1.DateTime.local().toISO() || undefined });
            const newData = tagData.unshift(newItem);
            setTagData(newData);
            setEditing(ID_NEW);
            setEditingTag(newItem);
        }
    };
    const handleVariantChange = (id, tagVariant = QTag_1.variants.NORMAL) => {
        let newEditing;
        if (tagVariant === QTag_1.variants.NORMAL) {
            newEditing = null;
        }
        // @ts-expect-error: This comparison appears to be unintentional because the types '"normal"' and '"edit"' have no overlap.
        if (tagVariant === QTag_1.variants.EDIT) {
            newEditing = id;
        }
        setEditing(newEditing);
    };
    const validateTag = (name) => {
        if (name === '') {
            dialogAlert('Unable to save tag', 'You must specify a name for this tag', () => {
                handleRequestCreate();
            }, ['Got It']);
            return false;
        }
        return true;
    };
    const removeNewItem = () => {
        const newDataIndex = tagData.findIndex((x) => x.id === ID_NEW);
        if (newDataIndex <= 0) {
            const newData = tagData.delete(newDataIndex);
            setTagData(newData);
            setEditingTag(null);
        }
    };
    const handleSave = (id, name, callback) => {
        if (validateTag(name)) {
            const dupTag = (0, utils_2.checkForDuplicateTag)(id, name, tagData);
            if (dupTag) {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                dialogAlert(`${name} already exists.`, 'You need to use a unique name', () => { }, ['Got It']);
            }
            else {
                let item = tagData.find((x) => x.id === id);
                if (item === undefined) {
                    item = editingTag !== null ? editingTag : undefined;
                }
                const toSave = item === null || item === void 0 ? void 0 : item.set('name', name);
                if (id === ID_NEW) {
                    core_1.tracker.track(core_1.tracker.events.tagCreate);
                    const newId = (0, uuid_1.v4)().toUpperCase();
                    createItem(toSave.merge({ id: undefined, clientId: newId }));
                    removeNewItem();
                }
                else {
                    core_1.tracker.track(core_1.tracker.events.tagEdit);
                    setEditingTag(null);
                    updateItem(toSave);
                }
                if (callback) {
                    callback(dupTag);
                }
            }
        }
    };
    const setEditTag = (newEditingTag) => {
        setEditingTag(newEditingTag);
    };
    const handleDelete = (id) => {
        const tag = tagData.find((x) => x.id === id);
        let dialogMessage = 'Are you sure you want to delete the tag?';
        let dialogTitle = 'DELETE TAG';
        const dialogActions = ['Cancel'];
        const excludedTypes = ['property', 'business'];
        if (excludedTypes.includes(tag === null || tag === void 0 ? void 0 : tag.type)) {
            dialogTitle = 'CAN\'T DELETE TAG';
            dialogMessage = 'This tag is being used in Business or Property.';
        }
        else {
            dialogActions.push('Delete');
        }
        /*
         * Remove references to this tag in all transactions
         */
        let txnsToChange = txnsProps.transactionsById.filter((txn) => (0, utils_1.txnHasTag)(txn, tag));
        txnsToChange = txnsToChange.map((txn) => (0, utils_1.removeTxnTag)(txn, tag)).toList();
        /*
         * Remove references to this tag in all scheduled transaction models
         */
        let scheduledTxnsToChange = txnsProps.scheduledTransactions.filter((stxn) => (0, utils_1.txnHasTag)(stxn.transaction, tag));
        scheduledTxnsToChange = scheduledTxnsToChange.map((stxn) => stxn.set('transaction', (0, utils_1.removeTxnTag)(stxn.transaction, tag))).toList();
        /*
         * Remove references to this tag in all memorized transactions
         */
        let memPayeesToChange = txnsProps.memTransactionsById.filter((memPayee) => (0, utils_1.txnHasTag)(memPayee, tag));
        memPayeesToChange = memPayeesToChange.map((memPayee) => (0, utils_1.removeTxnTag)(memPayee, tag)).toList();
        if (txnsToChange.size > 0 || scheduledTxnsToChange.size > 0 || memPayeesToChange.size > 0) {
            const s = txnsToChange.size > 1 ? 's' : '';
            const s2 = scheduledTxnsToChange.size > 1 ? 's' : '';
            const s3 = memPayeesToChange.size > 1 ? 's' : '';
            const txnText = txnsToChange.size > 0 ? `${txnsToChange.size} transaction${s} ${scheduledTxnsToChange.size > 0 ? 'and' : ''} ` : '';
            const schedTxnText = scheduledTxnsToChange.size > 0 ? ` ${scheduledTxnsToChange.size} scheduled transaction${s2} ` : '';
            const memPayeeText = memPayeesToChange.size > 0 ? ` ${memPayeesToChange.size} memorized payee${s3} ` : '';
            dialogMessage = `You have ${txnText} ${schedTxnText} ${memPayeeText} 
      using the tag ${tag === null || tag === void 0 ? void 0 : tag.name}. Are you sure you want to delete the tag ${tag === null || tag === void 0 ? void 0 : tag.name}?`;
        }
        dialogAlert(dialogTitle, dialogMessage, (retObj) => {
            if ((retObj === null || retObj === void 0 ? void 0 : retObj.btnPressed) === 'Delete') {
                core_1.tracker.track(core_1.tracker.events.tagDelete);
                deleteItem(tag === null || tag === void 0 ? void 0 : tag.set('isDeleted', true), txnsToChange, scheduledTxnsToChange, memPayeesToChange);
            }
        }, dialogActions);
    };
    const showSaveChangesDialog = (saveCallback, cancelCallback, tagValue) => {
        if (!(0, utils_2.checkForDuplicateTag)(0, tagValue, tagData, true)) {
            dialogAlert('Unsaved tag', 'Do you want to save the changes.', (retObj) => {
                if ((retObj === null || retObj === void 0 ? void 0 : retObj.btnPressed) === 'Cancel' || (retObj === null || retObj === void 0 ? void 0 : retObj.btnPressed) === 'Escape') {
                    if (cancelCallback) {
                        cancelCallback();
                    }
                }
                if ((retObj === null || retObj === void 0 ? void 0 : retObj.btnPressed) === 'Save') {
                    if (saveCallback) {
                        saveCallback();
                    }
                }
            }, ['Cancel', 'Save']);
        }
        else {
            if (cancelCallback) {
                cancelCallback();
            }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            dialogAlert(`${tagValue.trim()} already exists.`, 'You need to use a unique name', () => { }, ['Got It']);
        }
    };
    const renderTagItems = () => tagData.map((tag, index) => {
        let tagVariant = QTag_1.variants.NORMAL;
        if (tag.id === editing) {
            // @ts-expect-error: Type '"edit" | "new"' is not assignable to type '"normal"'.
            tagVariant = tag.id === ID_NEW ? QTag_1.variants.NEW : QTag_1.variants.EDIT;
        }
        return (<Box_1.default position="relative" key={tag.id || ID_NEW}>
          <Dump_1.default obj={tag}/>
          <QTag_1.default classname={classes.chip} key={tag.id || ID_NEW} id={tag.id} index={index} tagValue={tag.name} tagVariant={tagVariant} 
        // @ts-expect-error: Types of parameters 'tagVariant' and 'variant' are incompatible.
        changeUiState={handleVariantChange} handleSave={handleSave} handleDelete={handleDelete} 
        // @ts-expect-error: Type 'Record<string, any>' is missing the following properties from type 'string[]': length, pop, push, concat, and 29 more.
        tagsCharFilter={tagsCharFilter} removeNewItem={removeNewItem} showSaveChangesDialog={showSaveChangesDialog} setEditingTag={setEditTag}/>
        </Box_1.default>);
    });
    return (<>
      <Grid_1.default className={classes.sectionHeadline} container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Typography_1.default variant="h5" className={classes.headlineText}>
          <tag_icon_inline_svg_1.default className={classes.headlineIcon}/>
          Tags
        </Typography_1.default>
        <QButton_1.default id="tags-add-new-button" variant="contained" onClick={handleRequestCreate}>
          <Add_1.default className={classes.iconSpacing}/> TAGS
        </QButton_1.default>
      </Grid_1.default>
      <Grid_1.default className={classes.tagsContainer} container>
        {tagData.size ?
            renderTagItems() :
            !isLoading &&
                <Typography_1.default className={classes.noData} component="p" variant="subtitle2">
              No tags available. Please click the button to add a new tag
            </Typography_1.default>}
      </Grid_1.default>
    </>);
};
exports.default = (0, QDialogs_1.default)()(TagsSettings);
